"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../utils/hooks");

var _helpers = require("../../utils/helpers");

var _HeaderUtility = _interopRequireDefault(require("./HeaderUtility"));

var _HeaderPrimary = _interopRequireDefault(require("./HeaderPrimary"));

var _HeaderSecondary = _interopRequireDefault(require("./HeaderSecondary"));

var Header = function Header(_ref) {
  var cta = _ref.cta,
      homeLink = _ref.homeLink,
      logoImage = _ref.logoImage,
      place = _ref.place,
      primaryActive = _ref.primaryActive,
      primaryLinks = _ref.primaryLinks,
      secondaryActive = _ref.secondaryActive,
      secondaryLinks = _ref.secondaryLinks,
      userBtn = _ref.userBtn,
      utilityLinks = _ref.utilityLinks;

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isNavOpen = _ref3[0],
      setIsNavOpen = _ref3[1];

  var closeNav = function closeNav() {
    setIsNavOpen(false);
    (0, _helpers.lockWindow)(false);
  };

  var openNav = function openNav() {
    setIsNavOpen(true);
    (0, _helpers.lockWindow)(true);
  };

  var handleOpenNav = function handleOpenNav() {
    if (isNavOpen) {
      closeNav();
    } else {
      openNav();
    }
  };

  var _ref4 = (0, _emotionTheming.useTheme)(),
      breakpoints = _ref4.breakpoints,
      header = _ref4.header;

  var navBreakpoint = breakpoints[header.primary.breakpoint];
  var windowWidth = (0, _hooks.useWindowWidth)();
  var isLargeNav = windowWidth >= parseInt(navBreakpoint, 10);
  var isSecondaryHeaderVisible = secondaryLinks.length > 0 && isLargeNav;
  (0, _react.useEffect)(function () {
    var resizeHandler = function resizeHandler() {
      if (window.innerWidth >= parseInt(navBreakpoint, 10)) {
        closeNav();
      }
    };

    window.addEventListener('resize', resizeHandler);
    return function () {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [navBreakpoint]);
  var headerUtilityProps = {
    links: utilityLinks,
    userBtn: userBtn
  };
  var headerPrimaryProps = {
    active: primaryActive,
    closeNav: closeNav,
    cta: cta,
    handleOpenNav: handleOpenNav,
    homeLink: homeLink,
    isLargeNav: isLargeNav,
    isNavOpen: isNavOpen,
    links: primaryLinks,
    logoImage: logoImage,
    place: place
  };
  var headerSecondaryProps = {
    links: secondaryLinks,
    active: secondaryActive
  };
  return /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement(_HeaderUtility.default, headerUtilityProps), /*#__PURE__*/_react.default.createElement(_HeaderPrimary.default, headerPrimaryProps), isSecondaryHeaderVisible && /*#__PURE__*/_react.default.createElement(_HeaderSecondary.default, headerSecondaryProps));
};

Header.propTypes = {
  cta: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired
  }),
  homeLink: _propTypes.default.string,
  logoImage: _propTypes.default.shape(Object),
  place: _propTypes.default.oneOf(['legacyHeader', 'header']),
  primaryActive: _propTypes.default.string,
  primaryLinks: _propTypes.default.arrayOf(Object),
  secondaryLinks: _propTypes.default.arrayOf(Object),
  secondaryActive: _propTypes.default.string,
  userBtn: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  utilityLinks: _propTypes.default.arrayOf(Object)
};
Header.defaultProps = {
  cta: null,
  homeLink: '/',
  logoImage: null,
  place: 'legacyHeader',
  primaryActive: '',
  primaryLinks: [],
  secondaryLinks: [],
  secondaryActive: '',
  userBtn: null,
  utilityLinks: []
};
var _default = Header;
exports.default = _default;